// start:ng42.barrel
import './cca-timeSlot.component';
// end:ng42.barrel

